import { render, staticRenderFns } from "./VaVideoFileInput.vue?vue&type=template&id=313280b5&scoped=true&"
import script from "./VaVideoFileInput.vue?vue&type=script&lang=js&"
export * from "./VaVideoFileInput.vue?vue&type=script&lang=js&"
import style0 from "./VaVideoFileInput.vue?vue&type=style&index=0&id=313280b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313280b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFileInput,VIcon})
